<template>
  <div class="chart-bar">
    <el-carousel height="100%" :autoplay="false" style="width: 100%;height: 100%" arrow="never">
      <el-carousel-item autoplay="false">
        <div class="chart-card">
          <div class="card-item">
            <div class="card-title">
              <div>各地级以上市工商联会员入库情况分析</div>
            </div>
            <div class="card-content members-above-city-chart">
              <div class="flex-between">
                <div class="flex-between chart-ys">
                </div>
                <ElementSelect
                    :val="membersAboveCitySelectYear"
                    :options="membersAboveCityYears"
                    @change="
                    (e) => {
                      membersAboveCitySelectYear = e;
                      getMembersAboveCity()
                    }
                  "
                    class="ml12"
                />
                <!-- <span id="btn-link" @click="handleLink(4)">关联地图展示</span> -->
              </div>
              <v-chart ref="members-above-city-chart" id="membersAboveCityChart" class="bar-chart"
                       :options="membersAboveCityChartOption" width="100%" height="100%"/>
            </div>
          </div>
          <div class="card-item l2-1">
            <div class="card-title">
              <div>全省工商联商会数量情况分析</div>
            </div>
            <div class="card-content members-above-city-chart">
              <div class="flex-between">
                <div class="flex-between chart-ys">
                </div>
                <ElementSelect
                    :val="provinceCocAmountAnalysisSelectYear"
                    :options="provinceCocAmountAnalysisYears"
                    @change="
                    (e) => {
                      provinceCocAmountAnalysisSelectYear = e;
                      getProvinceCocAmountAnalysis();
                    }
                  "
                    class="ml12"
                />
                <!-- <span id="btn-link" @click="handleLink(4)">关联地图展示</span> -->
              </div>
    <!--          <v-chart ref="provinceCocAmountAnalysisChart" id="provinceCocAmountAnalysisChart" class="bar-chart"-->
    <!--                   :options="provinceCocAmountAnalysisChartOption" width="100%"/>-->
              <div class="list-box">
                <div class="list-item flex-between" v-for="(item, i) in provinceCocAmountAnalysis">
                  <div class="item-l">
                    <b>{{ i + 1 }}</b
                    >{{ item.city || '-' }}
                  </div>
                  <div class="item-c">
                    县级商会：{{ item.county_coc_amount || '-' }}
                  </div>
                  <div class="item-c">
                    市级商会：{{ item.city_coc_amount || '-' }}
                  </div>
                  <!-- <div class="item-r"><i>--</i>未变</div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="card-item l2-3">
            <div class="card-title">
              <div>全省工商联商会党组织成立情况</div>
            </div>
            <div class="card-content members-above-city-chart">
              <div class="flex-between">
                <div>
                  <!-- <span id="btn-link" @click="handleLink(6)">关联地图展示</span> -->
                </div>
                <ElementSelect
                    :val="provinceCocPartyOrgEstablishmentSituationSelectYear"
                    :options="provinceCocPartyOrgEstablishmentSituationYears"
                    @change="
                    (e) => {
                      provinceCocPartyOrgEstablishmentSituationSelectYear = e;
                      getProvinceCocPartyOrgEstablishmentSituation();
                    }
                  "
                    class="ml12"
                />
              </div>
              <v-chart ref="province-coc-party-org-establishment-situation-chart"
                       id="provinceCocPartyOrgEstablishmentSituationChart" class="bar-chart"
                       :options="provinceCocPartyOrgEstablishmentSituationChartOption" width="100%"/>
            </div>
          </div>
        </div>
      </el-carousel-item>
      <el-carousel-item autoplay="false">
        <div class="chart-card">
      <div class="card-item">
        <div class="card-title">
          <div>工商联各级会员占比情况</div>
        </div>
        <div class="card-content members-above-city-chart">
          <div class="flex-between">
            <div></div>
            <ElementSelect
                :val="allLevelsMembersProportionSelectYear"
                :options="allLevelsMembersProportionYears"
                @change="
                (e) => {
                  allLevelsMembersProportionSelectYear = e;
                  getAllLevelsMembersProportion();
                }
              "
                class="ml12"
            />
          </div>
          <AllLevelsMembersProportion ref="allLevelsMembersProportionChart"
                                      :search-data="allLevelsMembersProportionChartData" :show-index="1"
                                      chart-name="allLevelsMembersProportionChart"/>
        </div>
      </div>
      <div class="card-item l2-2">
        <div class="card-title">
          <div>全省工商联商会层级情况分析</div>
        </div>
        <div class="card-content">
          <div class="flex-between">
            <div class="flex-between chart-ys">

              <!-- <ElementSelect
                :val="dataTypeYS"
                :options="dataTypeYSList"
                @change="
                  (e) => {
                    dataTypeYS = e;
                    getYsList();
                  }
                "
              /> -->
            </div>
            <ElementSelect
                :val="provinceCocLevelSituationAnalysisSelectYear"
                :options="provinceCocLevelSituationAnalysisYears"
                @change="
                (e) => {
                  provinceCocLevelSituationAnalysisSelectYear = e;
                  getProvinceCocLevelSituationAnalysis();
                }
              "
                class="ml12"
            />
            <!-- <span id="btn-link" @click="handleLink(4)">关联地图展示</span> -->
          </div>
          <ProvinceCocLevelSituationAnalysis ref="provinceCocLevelSituationAnalysisChart"
              :search-data="provinceCocLevelSituationAnalysisChartData" :show-index="0"
              chart-name="provinceCocLevelSituationAnalysisChart" @click-chart="handleClickChart($event)"/>
        </div>
      </div>
      <div class="card-item l2-3">
        <div class="card-title">
          <div>全省工商联商会类型情况分析</div>
        </div>
        <div class="card-content">
          <div class="flex-between">
            <div>
              <!-- <span id="btn-link" @click="handleLink(6)">关联地图展示</span> -->
            </div>
            <ElementSelect
                :val="provinceCocTypeAnalysisSelectYear"
                :options="provinceCocTypeAnalysisYears"
                @change="
                (e) => {
                  provinceCocTypeAnalysisSelectYear = e;
                  getProvinceCocTypeAnalysis()
                }
              "
            />
          </div>
          <ProvinceCocTypeAnalysis ref="provinceCocTypeAnalysisChart"
             :search-data="provinceCocTypeAnalysisChartData" :show-index="0"
             chart-name="provinceCocTypeAnalysisChart"/>
        </div>
      </div>
    </div>
      </el-carousel-item>
    </el-carousel>
    <EleDialog id="chamber_of_commerce_base_info" title="工商联商会信息"
               :visible.sync="chamberOfCommerceBaseInfoShow"
               class="chamber-of-commerce-base-info" width="20%">
      <el-table
          :data="chamberOfCommerceBaseInfo"
          style="width: 100%;margin-bottom: 20px;;overflow:unset"
          row-key="chamber_of_commerce_name"
          border
          default-expand-all
          height="60%"
          :header-cell-style="{textAlign: 'center'}"
          :cell-style="{ textAlign: 'center' }"
          @cell-click="chamberOfCommerceBaseInfoCellClick">
        <el-table-column
            type="index"
            label="序号">
        </el-table-column>
        <el-table-column
            prop="chamber_of_commerce_name"
            label="商会名称">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="chamber_of_commerce_base_info_detail" title="工商联商会详情"
               :visible.sync="chamberOfCommerceBaseInfoDetailShow"
               class="chamber-of-commerce-base-info-detail">
      <el-row>
        <el-col :span="6">
          <div class="item-label text-align-right">
            商会名称：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.chamber_of_commerce_name || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            成立时间：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.establishment_time || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            办公地址：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.office_address || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            会长姓名：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.presidents_name || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            会长所属公司：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.president_belong_company || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            所属公司职务：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.presidents_company_position || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            会长在省工商联任职情况：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.presidents_position_explanation || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            秘书处联系人：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.secretariat_contact_person || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            党支部成立时间：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.party_branch_establishment_time || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row style="padding-top: 10px">
        <el-col :span="6">
          <div class="item-label text-align-right">
            运作情况：
          </div>
        </el-col>
        <el-col :span="16">
          <div class="item-label">
            {{chamberOfCommerceBaseInfoCurrentRow.operation_status || '-'}}
          </div>
        </el-col>
      </el-row>
    </EleDialog>
  </div>
</template>

<script>
import drawBar from '../chartJs/chartScienceFunds';
import drawBar2 from '../chartJs/chartLicense';
import drawBar3 from '../chartJs/chartPrivateTaxes';
import FinancialService from './FinancialService.vue';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import TabList from '../../../components/tabList';
import MarketSubjectType from './MarketSubjectType';
import MarketMainIndustry from './MarketMainIndustry.vue';
import ElementSelect from '../../../components/element-select';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';


import CityMemberInWareHouseCase from './CityMemberInWareHouseCase.vue';

import PartyOrganizationEstablishedCase from './PartyOrganizationEstablishedCase.vue';
import ChamberOfCommerceAmount from './ChamberOfCommerceAmount.vue';
import ChamberOfCommerceLevelCase from './ChamberOfCommerceLevelCase.vue';
import ChamberOfCommerceTypeCase from './ChamberOfCommerceTypeCase.vue';

import DisaggregatedStatistical from './DisaggregatedStatistical';
// import drawAnyBar from "@/views/home/chartJs/bar";
import drawAnyBar from "../chartJs/rotateComputeBar";
import drawBarAndLine from "@/views/home/chartJs/rotateBarAndLine";
import { config } from '@/views/home/chartJs/chartCommon';
import echarts from "echarts";
import AllLevelsMembersProportion from './AllLevelsMembersProportion.vue';
import ProvinceCocLevelSituationAnalysis from './ProvinceCocLevelSituationAnalysis.vue';
import ProvinceCocTypeAnalysis from './ProvinceCocTypeAnalysis.vue';

import Decimal from 'decimal.js';
export default {
  name: 'MemberRight',
  components: { ElementSelect, ComTable, TabList, MarketSubjectType, MarketMainIndustry,
    CompModal, FinancialService,
    CityMemberInWareHouseCase, AllLevelsMembersProportion, PartyOrganizationEstablishedCase,
    ChamberOfCommerceAmount, ChamberOfCommerceLevelCase, ChamberOfCommerceTypeCase,
    DisaggregatedStatistical, ProvinceCocLevelSituationAnalysis, ProvinceCocTypeAnalysis
  },
  props: {
    yearP: {
      type: Number,
      default: 2024,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      membersAboveCityYears: [],
      membersAboveCitySelectYear: '',
      membersAboveCity: [],
      membersAboveCityChartOption: [],
      allLevelsMembersProportionYears: [],
      allLevelsMembersProportionSelectYear: '',
      allLevelsMembersProportion: {},
      allLevelsMembersProportionChartData: [],
      provinceCocPartyOrgEstablishmentSituationYears: [],
      provinceCocPartyOrgEstablishmentSituationSelectYear: '',
      provinceCocPartyOrgEstablishmentSituation: [],
      provinceCocPartyOrgEstablishmentSituationChartOption: [],
      provinceCocAmountAnalysisYears: [],
      provinceCocAmountAnalysisSelectYear: '',
      provinceCocAmountAnalysis: [],
      provinceCocAmountAnalysisChartOption: [],
      provinceCocLevelSituationAnalysisYears: [],
      provinceCocLevelSituationAnalysisSelectYear: '',
      provinceCocLevelSituationAnalysis: {},
      provinceCocLevelSituationAnalysisChartData: [],
      provinceCocTypeAnalysisYears: [],
      provinceCocTypeAnalysisSelectYear: '',
      provinceCocTypeAnalysis: {},
      provinceCocTypeAnalysisChartData: [],
      chamberOfCommerceBaseInfo: [],
      chamberOfCommerceBaseInfoShow: false,
      chamberOfCommerceBaseInfoCurrentRow: {},
      chamberOfCommerceBaseInfoDetailShow: false

    };
  },
  created() {
    this.getMembersAboveCityYear();
    this.getAllLevelsMembersProportionYear();
    this.getProvinceCocPartyOrgEstablishmentSituationYear();
    this.getProvinceCocAmountAnalysisYear();
    this.getProvinceCocLevelSituationAnalysisYear();
    this.getProvinceCocTypeAnalysisYear();



  },
  computed: {
  },
  watch: {
  },
  methods: {
    chamberOfCommerceBaseInfoCellClick(row,column,event,cell){
      this.chamberOfCommerceBaseInfoCurrentRow = row;
      this.chamberOfCommerceBaseInfoDetailShow = true;
    },
    handleClickChart(params) {
      this.getChamberOfCommerceBaseInfo()
    },
    getChamberOfCommerceBaseInfo(){
      this.$api.member
          .getChamberOfCommerceBaseInfo().then((res) => {
        if (res.data.data){
          this.chamberOfCommerceBaseInfo = res.data.data;
          this.chamberOfCommerceBaseInfoShow = true;
        }
      });
    },
    getMembersAboveCityYear(){
      this.$api.member
          .getMembersAboveCityYear().then((res) => {
        if (res.data.data){
          this.membersAboveCityYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.membersAboveCitySelectYear = res.data.data[0];
          this.getMembersAboveCity();
        }
      });
    },

    getMembersAboveCity(){
      this.$api.member
          .getMembersAboveCity({
            year: this.membersAboveCitySelectYear
          }).then((res) => {
        if (res.data.data){
          this.membersAboveCity = res.data.data;
          let names = ['会员总数', '会员入库数'];
          let list = {
            yAxis: {
              names: [''],
              name: ''
            },
            names: Array.from(names),
            data: [],
          };
          list.names = names;
          list.showLabel = true;
          if (this.membersAboveCity) {
            for (let i = 0; i < this.membersAboveCity.length; i++) {
              if (this.membersAboveCity[i].city){
                let obj = {};
                obj['城市'] = (this.membersAboveCity[i].city);
                obj['会员总数'] = (this.membersAboveCity[i].member_amount);
                obj['会员入库数'] = (this.membersAboveCity[i].member_instorage_amount);
                list.data.push(obj);
              }
            }
          }
          // this.chartData = list;
          this.membersAboveCityChartOption = drawAnyBar(list);
          this.$nextTick(() => {
            this.$refs['members-above-city-chart'].resize()
          })
          // this.getMembersAboveCityChartOption()
        }
      });
    },

    getMembersAboveCityChartOption() {
      let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, xAxis, legend } = config;
      let yAxis = [];
      let memberInstorageData = [],
          memberTotalData = [];
      if (this.membersAboveCity) {
        for (let i = 0; i < this.membersAboveCity.length; i++) {
          if (this.membersAboveCity[i].city){
            memberInstorageData.push(this.membersAboveCity[i].member_instorage_amount);
            memberTotalData.push(this.membersAboveCity[i].member_amount);
            yAxis.push(this.membersAboveCity[i].city);
          }
        }
      }
      let series = [];
      let names = ['会员总数', '会员入库数'];
      let memberInstorageSeriesObj = {
        name: names[1],
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          position: 'right',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
          normal: {
            show: true,
            /*
            *处理横坐标负半轴这边的  "柱状"  显示的数
            *后台传过来是数组过大进行计算
             */
            formatter: function (value) {
              if (value.data){
                const num1 = new Decimal(10000);
                const num2 = new Decimal(value.data);
                const value = num2.dividedBy(num1).toNumber().toFixed(2);
                return value
              } else {
                return value.data
              }
            },
          }
        },
        emphasis: {
          focus: 'series'
        },
        data: memberInstorageData,
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[0],
              },
              {
                offset: 0.9,
                color: barColorOpacity[0],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[0],
          },
        }
      };
      let memberTotalSeriesObj = {
        name: names[0],
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          position: 'left',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
          normal: {
            show: true,
            /*
            *处理横坐标负半轴这边的  "柱状"  显示的数
            *后台传过来是数组过大进行计算
             */
            formatter: function (value) {
              if (value.data){
                const num1 = new Decimal(10000);
                const num2 = new Decimal(value.data);
                const value = num2.dividedBy(num1).toNumber().toFixed(2);
                return value
              } else {
                return value.data
              }
            },
          }
        },
        emphasis: {
          focus: 'series'
        },
        data: memberTotalData,
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[1],
              },
              {
                offset: 0.9,
                color: barColorOpacity[1],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[1],
          },
        }
      }
      series.push(memberTotalSeriesObj);
      series.push(memberInstorageSeriesObj);

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            color: fontColor,
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize,
          },
        },
        grid: {
          left: 10,
          top: '15%',
          right: 15,
          bottom: 0,
          containLabel: true,
        },
        legend: {
          data: names,
          textStyle: {
            color: '#dcdcdc',
            fontSize,
          },
          show: series.length > 1 ? true : false,
        },
        xAxis,
        yAxis: [
          {
            type: 'value',
            nameTextStyle: {
              color: fontColor,
              fontSize,
              // padding: bool ? [0, 0, 0, -20] : [0, 0, -8, 0],
            },
            axisLabel: {
              formatter: function (value) {
                if (value.data){
                  const num1 = new Decimal(10000);
                  const num2 = new Decimal(value.data);
                  const value = num2.dividedBy(num1).toNumber().toFixed(2);
                  return value
                } else {
                  return value.data
                }
              },
              textStyle: {
                color: fontColor,
                fontSize,
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: 'rgba(56, 89, 130, 0.4)',
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(56, 89, 130, 0.4)',
              },
            },
          }
        ],
        series: series
      }
      this.membersAboveCityChartOption = option;
    },

    getAllLevelsMembersProportionYear(){
      this.$api.member
          .getAllLevelsMembersProportionYear().then((res) => {
        if (res.data.data){
          this.allLevelsMembersProportionYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.allLevelsMembersProportionSelectYear = res.data.data[0];
          this.getAllLevelsMembersProportion();
        }
      });
    },

    getAllLevelsMembersProportion(){
      this.$api.member
          .getAllLevelsMembersProportion({
            year: this.allLevelsMembersProportionSelectYear
          }).then((res) => {
        if (res.data.data){
          this.allLevelsMembersProportion = res.data.data;
          let chartObj = []
          let provinceMemberData = {
            name: '省级会员',
            percent: this.allLevelsMembersProportion.province_member_amount_percent,
            value: this.allLevelsMembersProportion.province_member_amount,
          }
          chartObj.push(provinceMemberData);
          let cityMemberData = {
            name: '市级会员',
            percent: this.allLevelsMembersProportion.city_member_amount_percent,
            value: this.allLevelsMembersProportion.city_member_amount,
          }
          chartObj.push(cityMemberData);
          let countyMemberData = {
            name: '县级会员',
            percent: this.allLevelsMembersProportion.county_amount_percent,
            value: this.allLevelsMembersProportion.county_amount,
          }
          chartObj.push(countyMemberData);

          this.allLevelsMembersProportionChartData = chartObj;
        }
      });
    },

    getProvinceCocPartyOrgEstablishmentSituationYear(){
      this.$api.member
          .getProvinceCocPartyOrgEstablishmentSituationYear().then((res) => {
        if (res.data.data){
          this.provinceCocPartyOrgEstablishmentSituationYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.provinceCocPartyOrgEstablishmentSituationSelectYear =
              res.data.data[0];
          this.getProvinceCocPartyOrgEstablishmentSituation();
        }
      });
    },

    getProvinceCocPartyOrgEstablishmentSituation(){
      this.$api.member
          .getProvinceCocPartyOrgEstablishmentSituation({
            year: this.provinceCocPartyOrgEstablishmentSituationSelectYear
          }).then((res) => {
        if (res.data.data){
          this.provinceCocPartyOrgEstablishmentSituation = res.data.data;
          let names = ['商会总数', '党组织数', '党组织覆盖率'];
          let list = {
            yAxis: {
              names: [''],
            },
            names: Array.from(names),
            data: [],
          };
          list.names = names;
          list.showLabel = true;
          if (this.provinceCocPartyOrgEstablishmentSituation) {
            for (let i = 0; i < this.provinceCocPartyOrgEstablishmentSituation.length; i++) {
              if (this.provinceCocPartyOrgEstablishmentSituation[i].city){
                let obj = {};
                obj['城市'] = (this.provinceCocPartyOrgEstablishmentSituation[i].city);
                obj['商会总数'] = (this.provinceCocPartyOrgEstablishmentSituation[i].coc_amount);
                obj['党组织数'] = (this.provinceCocPartyOrgEstablishmentSituation[i].party_organizations_amount);
                obj['党组织覆盖率'] = (this.provinceCocPartyOrgEstablishmentSituation[i].percent);
                list.data.push(obj);
              }
            }
          }
          // this.chartData = list;
          this.provinceCocPartyOrgEstablishmentSituationChartOption = drawBarAndLine(list);
          this.$nextTick(() => {
            this.$refs['province-coc-party-org-establishment-situation-chart'].resize()
          })
        }
      });
    },

    getProvinceCocAmountAnalysisYear(){
      this.$api.member
          .getProvinceCocAmountAnalysisYear().then((res) => {
        if (res.data.data){
          this.provinceCocAmountAnalysisYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.provinceCocAmountAnalysisSelectYear = res.data.data[0];
          this.getProvinceCocAmountAnalysis();
        }
      });
    },

    getProvinceCocAmountAnalysis(){
      this.$api.member
          .getProvinceCocAmountAnalysis({
            year: this.provinceCocAmountAnalysisSelectYear
          }).then((res) => {
        if (res.data.data){
          this.provinceCocAmountAnalysis = res.data.data;
          // this.$nextTick(
          //     this.getProvinceCocAmountAnalysisChartOption()
          // )
        }
      });
    },
    getResetChart(refName) {
      this.$refs[refName].clear();
    },

    getProvinceCocAmountAnalysisChartOption() {
      let { fontColor, fontSize, barColor, barColorOpacity, barLineBasicColor, tooltip, xAxis, legend } = config;
      let yAxis = [];
      let cityCocAmountData = [],
          countyCocAmountData = [];
      if (this.provinceCocAmountAnalysis) {
        for (let i = 0; i < this.provinceCocAmountAnalysis.length; i++) {
          if (this.provinceCocAmountAnalysis[i].city){
            cityCocAmountData.push(- this.provinceCocAmountAnalysis[i].city_coc_amount);
            countyCocAmountData.push(this.provinceCocAmountAnalysis[i].county_coc_amount);
            yAxis.push(this.provinceCocAmountAnalysis[i].city);
          }
        }
      }
      let series = [];
      let names = ['市级商会数', '区县商会数'];
      let countyCocAmountSeriesObj = {
        name: names[1],
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          position: 'right',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
        },
        emphasis: {
          focus: 'series'
        },
        data: countyCocAmountData,
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[0],
              },
              {
                offset: 0.9,
                color: barColorOpacity[0],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[0],
          },
        }
      };
      let cityCocAmountSeriesObj = {
        name: names[0],
        type: 'bar',
        stack: 'Total',
        label: {
          show: true,
          position: 'left',
          color: fontColor,
          fontSize,
          fontFamily: 'Geometr706 BlkCn BT',
          normal: {
            show: true,
            /*
            *处理横坐标负半轴这边的  "柱状"  显示的数
            *后台传过来是负数，显示时是正数
             */
            formatter: function (value) {
              return Math.abs(value.data);
            },
          }
        },
        emphasis: {
          focus: 'series'
        },
        data: cityCocAmountData,
        itemStyle: {
          normal: {
            show: true,
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                offset: 0.4,
                color: barColor[1],
              },
              {
                offset: 0.9,
                color: barColorOpacity[1],
              },
            ]),
            borderWidth: 1,
            borderColor: barColor[1],
          },
        }
      }
      series.push(countyCocAmountSeriesObj);
      series.push(cityCocAmountSeriesObj);

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          textStyle: {
            color: fontColor,
            fontStyle: 'normal',
            fontFamily: '微软雅黑',
            fontSize,
          },
          formatter: function (params) {
            let res = '';
            params.forEach(function (item, index) {
              if (index === 0) {
                res += item.name + '<br/>';
              }
              res += item.seriesName + ': ' + Math.abs(item.value) + '<br/>';
            });
            return res;
          }
        },
        grid: {
          left: 10,
          top: '15%',
          right: 15,
          bottom: 0,
          containLabel: true,
        },
        legend: {
          data: names,
          textStyle: {
            color: '#dcdcdc',
            fontSize,
          },
          show: series.length > 1 ? true : false,
        },
        xAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: function (value) {
                return Math.abs(value); // 自定义正负数轴标签
              },
              color: fontColor,
              textStyle: {
                fontSize,
              },
              interval: 0,
            },
          }
        ],
        yAxis: [
          {
            axisLabel: {
              formatter: '{value}',
              textStyle: {
                color: fontColor,
                fontSize: 8,
              },
            },
            type: 'category',
            axisTick: {
              show: false
            },
            data: yAxis
          }
        ],
        series: series
      }
      this.provinceCocAmountAnalysisChartOption = option;
    },

    getProvinceCocLevelSituationAnalysisYear(){
      this.$api.member
          .getProvinceCocLevelSituationAnalysisYear().then((res) => {
        if (res.data.data){
          this.provinceCocLevelSituationAnalysisYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.provinceCocLevelSituationAnalysisSelectYear =
              res.data.data[0];
          this.getProvinceCocLevelSituationAnalysis();

        }
      });
    },

    getProvinceCocLevelSituationAnalysis(){
      this.$api.member
          .getProvinceCocLevelSituationAnalysis({
            year: this.provinceCocLevelSituationAnalysisSelectYear
          }).then((res) => {
        if (res.data.data){
          this.provinceCocLevelSituationAnalysis = res.data.data;
          let chartObj = []
          let provinceData = {
            name: '省工商联商会',
            value: this.provinceCocLevelSituationAnalysis.province_coc_amount,
          }
          chartObj.push(provinceData);
          let cityData = {
            name: '地级以上市工商联商会',
            value: this.provinceCocLevelSituationAnalysis.city_coc_amount,
          }
          chartObj.push(cityData);
          let countyData = {
            name: '县级工商联商会',
            value: this.provinceCocLevelSituationAnalysis.county_coc_amount,
          }
          chartObj.push(countyData);

          this.provinceCocLevelSituationAnalysisChartData = chartObj;
        }
      });
    },

    getProvinceCocTypeAnalysisYear(){
      this.$api.member
          .getProvinceCocTypeAnalysisYear().then((res) => {
        if (res.data.data){
          this.provinceCocTypeAnalysisYears = res.data.data.map((item) => {
            return {
              label: item,
              value: item
            }
          });
          this.provinceCocTypeAnalysisSelectYear = res.data.data[0];
          this.getProvinceCocTypeAnalysis();
        }
      });
    },

    getProvinceCocTypeAnalysis(){
      this.$api.member
          .getProvinceCocTypeAnalysis({
            year: this.provinceCocTypeAnalysisSelectYear
          }).then((res) => {
        if (res.data.data){
          this.provinceCocTypeAnalysis = res.data.data;
          let chartObj = []
          let industryCocAmountData = {
            name: '行业商会',
            value: this.provinceCocTypeAnalysis.industry_coc_amount,
          }
          chartObj.push(industryCocAmountData);
          let townCocAmountData = {
            name: '镇街商会',
            value: this.provinceCocTypeAnalysis.town_coc_amount,
          }
          chartObj.push(townCocAmountData);
          let differentPlacesCocAmountData = {
            name: '异地商会',
            value: this.provinceCocTypeAnalysis.different_places_coc_amount,
          }
          chartObj.push(differentPlacesCocAmountData);
          let comprehensiveCocAmountData = {
            name: '综合商会',
            value: this.provinceCocTypeAnalysis.comprehensive_coc_amount,
          }
          chartObj.push(comprehensiveCocAmountData);
          let parkMarketCocAmountData = {
            name: '园区/市场商会',
            value: this.provinceCocTypeAnalysis.park_market_coc_amount,
          }
          chartObj.push(parkMarketCocAmountData);
          this.provinceCocTypeAnalysisChartData = chartObj;
        }
      });
    },


    handleLink(index) {
      this.$emit('handleLink', {
        index,
        dataType: this.dataType,
        year: this.year,
      });
    },

    openModal(e) {
      this.showEntDialog = true;
      if (e) this.search.cityName = e;
      this.getEntList();
    },

  },
  mounted() {
  },
};
</script>

<style lang="less" scoped>
//.chamber-of-commerce-base-info-detail {
//  display: flex;
//  flex-direction: row;
//}

.text-align-right {
  text-align: right;
}
&.chamber-of-commerce-base-info .el-table {
  background: #2c4c73;
}
.el-table__expand-icon {
  color: #ffffff
}
.members-above-city-chart{
  height: 443px;
}

&.members-above-city-chart .echarts {
  width: 100%;
  height: 420px;
}

.ml12 {
  margin-left: 12px;
}
.chart-bar {
  .chart-box();
  width: 100%;
  height: 100%;
  margin: 0;
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
  .chart-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    &:first-child {
      width: 100%;
    }
    .card-item {
      &:first-child {
        height: calc(100% / 3 - 10px);
      }
      + .card-item {
        //margin-top: 25px;
        height: calc(100% / 3 - 22px);
        //flex: 1;
        display: flex;
        flex-direction: column;
      }
    }
    .chart-ys {
      position: relative;
      /deep/ .el-cascader {
        // position: absolute;
        // top: 0;
        // left: 0;
        width: 130px;
        .el-input--suffix .el-input__inner {
          height: 28px;
          // padding-left: 44px;
          background: linear-gradient(
              0deg,
              rgba(0, 197, 250, 0.5) 0%,
              rgba(0, 197, 250, 0.48) 6%,
              rgba(0, 197, 250, 0.11) 100%
          );
          border-radius: 3px;
          border: none;
        }

        input {
          background: linear-gradient(
              0deg,
              rgba(0, 197, 250, 0.5) 0%,
              rgba(0, 197, 250, 0.48) 6%,
              rgba(0, 197, 250, 0.11) 100%
          );
          outline: none;
          border: none;
          color: #fff;
          font-size: 14px;
        }
      }
    }
    .l2-2 .card-content,
    .l2-3 .card-content {
      flex: 1;
    }
    .card-title {
      width: 100%;
      height: 36px;
      background: url('~img/market/market-card-title.png') no-repeat;
      background-size: 100% 100%;
      padding-left: 17px;
      box-sizing: border-box;
      div {
        font-family: 'AlibabaPB';
        font-weight: bold;
        font-size: 25px;
        color: #ffffff;
        line-height: 36px;
        // text-shadow: 0px 2px 8px rgba(5, 28, 55, 0.42);
        font-style: italic;
        background: linear-gradient(
            180deg,
            rgba(189, 232, 247, 1) 0%,
            rgba(191, 229, 252, 1) 20%,
            rgba(249, 253, 254, 1) 58.7646484375%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
    .card-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding-top: 2px;
      margin: -1px 1px 1px;
      background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
      border-radius: 4px;
      border: 1px solid;
      border-image: linear-gradient(0deg, rgba(154, 234, 255, 0.15), rgba(154, 234, 255, 0.15)) 1 1;
      border-top: none;
      .chart-con {
        .chart-box {
          // width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          align-items: center;
          // justify-content: space-between;
          // padding: 0 20px;
          .bar-box {
            position: relative;
            width: 28px;
            height: 100%;
            padding: 0 8.3%;
            &:after {
              position: absolute;
              left: 50%;
              bottom: 0;
              transform: translateX(-50%);
              width: 68px;
              height: 76px;
              content: '';
              background: url('~img/market/bar-bottom.png') center center no-repeat;
              background-size: cover;
            }
            &.bar0:after {
              background: url('~img/market/bar-bottom1.png') center center no-repeat;
              background-size: cover;
            }
            &.bar1:after {
              background: url('~img/market/bar-bottom2.png') center center no-repeat;
              background-size: cover;
            }
            &.bar2:after {
              background: url('~img/market/bar-bottom3.png') center center no-repeat;
              background-size: cover;
            }
          }
          .city-box {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: center;
            .num {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 14px;
              color: #ffffff;
              white-space: nowrap;
              &.city-0 {
                background: linear-gradient(0deg, #f63d01 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-1 {
                background: linear-gradient(0deg, #f48f00 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
              &.city-2 {
                background: linear-gradient(0deg, #82f40e 11%, #fff 60%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
              }
            }
            .name {
              font-family: Source Han Sans CN;
              font-weight: 400;
              font-size: 12px;
              color: #fdffff;
              white-space: nowrap;
            }
          }
          .bar-bg {
            width: 20px;
            height: 144px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            .bf {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              box-sizing: border-box;
              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, rgba(2, 26, 28, 0), rgba(24, 72, 117, 0.96));
              }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, rgba(24, 72, 117, 1), rgba(4, 61, 66, 0.3));
              }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: rgba(24, 72, 117, 0.6);
              }
            }
          }
          .cube {
            width: 20px;
            height: 100px;
            position: absolute;
            left: 50%;
            bottom: 16px;
            transform-style: preserve-3d;
            transform: translateX(-50%) rotateX(-30deg) rotateY(-45deg);
            z-index: 9;
            // animation: rotate 5s infinite linear;
            .face {
              position: absolute;
              width: 100%;
              height: 100%;
              background: rgba(255, 255, 255, 0.9);
              // border: 2px solid #ccc;
              box-sizing: border-box;

              &.front {
                transform: translateZ(10px);
                background: linear-gradient(to top, #1960b6, #3988ff);
              }
              // .back {
              //   transform: rotateY(180deg) translateZ(10px);
              //   background: linear-gradient(to right, #45a29e, #66bfa6);
              // }
              &.right {
                transform: rotateY(90deg) translateZ(10px);
                background: linear-gradient(to bottom, #072975, #1748c1);
              }
              // .left {
              //   transform: rotateY(-90deg) translateZ(10px);
              //   background: linear-gradient(to top, #ff6f61, #ffcc5c);
              // }
              &.top {
                height: 20px;
                transform: rotateX(90deg) translateZ(10px);
                background: #5dc9ff;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
              // .bottom {
              //   transform: rotateX(-90deg) translateZ(10px);
              //   background: linear-gradient(to left, #66bfa6, #45a29e);
              // }
            }
            &.cube-0 {
              .front {
                background: linear-gradient(to top, #d1602b, #ffaf83);
              }
              .right {
                background: linear-gradient(to bottom, #b1440e, #742111);
              }
              .top {
                background: #ff7c3a;
                // linear-gradient(to right, #ffcc5c, #ff6f61);
              }
            }
            &.cube-1 {
              .front {
                background: linear-gradient(to top, #ffc76e, #ffe6bf);
              }
              .right {
                background: linear-gradient(to bottom, #ac670d, #fed423);
              }
              .top {
                background: #ffcd7e;
              }
            }
            &.cube-2 {
              .front {
                background: linear-gradient(to top, #19a6b0, #00c67e);
              }
              .right {
                background: linear-gradient(to bottom, #07646a, #01b575);
              }
              .top {
                background: #60f9cc;
              }
            }
          }
        }
      }
    }
  }
  .wrapper {
    padding: 0 10px;
    * {
      box-sizing: border-box;
    }
  }
  .l1-1 {
    padding-top: 13px;
    padding-bottom: 28px;
    .sum-box {
      position: relative;
      width: 167px;
      height: 218px;
      padding: 28px 0;
      margin-right: 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      background: rgba(50, 98, 190, 0.11);
      border-top: 2px dashed rgba(104, 230, 255, 0.2);
      border-bottom: 2px dashed rgba(104, 230, 255, 0.2);
      .sum-i {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid #68e6ff;
        &.i1 {
          left: -1px;
          top: -2px;
          border-right: none;
          border-bottom: none;
        }
        &.i2 {
          right: -1px;
          top: -2px;
          border-left: none;
          border-bottom: none;
        }
        &.i3 {
          left: -1px;
          bottom: -2px;
          border-right: none;
          border-top: none;
        }
        &.i4 {
          right: -1px;
          bottom: -2px;
          border-left: none;
          border-top: none;
        }
      }
      .sum-img {
        width: 100px;
        height: 87px;
        background: url('~img/market/market-l-sum.png') no-repeat;
        background-size: 100% 100%;
      }
      .sum-h1 {
        font-family: Alibaba PuHuiTi 2;
        font-weight: normal;
        font-size: 18px;
        color: rgba(216, 226, 255, 0.8);
        line-height: 1;
        font-style: italic;
        margin: 20px;
      }
      .sum-h2 {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: rgba(239, 240, 241, 0.6);
        line-height: 1;
        b {
          margin-right: 8px;
          font-family: YouSheTitle;
          font-weight: 400;
          font-size: 26px;
          color: #e4edf7;
        }
      }
    }
    .sum-list {
      flex: 1;
      height: 100%;
      max-height: 218px;
      overflow-y: scroll;
      .list-item {
        + .list-item {
          margin-top: 18px;
        }
        .item-top {
          &.item1 {
            .top-l span {
              color: #fb3c00;
            }
            .top-r span {
              background: linear-gradient(0deg, #f63d01 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item2 {
            .top-l span {
              color: #fa9300;
            }
            .top-r span {
              background: linear-gradient(0deg, #f48f00 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item3 {
            .top-l span {
              color: #7ffc00;
            }
            .top-r span {
              background: linear-gradient(0deg, #82f40e 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          &.item4 {
            .top-l span {
              color: #49acff;
            }
            .top-r span {
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
          .top-l {
            font-family: Source Han Sans CN;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            span {
              font-family: Myriad Pro;
              font-weight: 400;
              font-size: 16px;
              color: #49acff;
              margin-right: 19px;
            }
          }
          .top-r {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 12px;
            color: #d8e2ff;
            font-style: italic;
            span {
              font-family: Geometr706 BlkCn BT;
              font-weight: 900;
              font-size: 18px;
              color: #ffffff;
              font-style: italic;
              background: linear-gradient(0deg, #f5f8ff 11%, #fff 90%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              padding-right: 3px;
              margin-right: 4px;
            }
          }
        }
        .item-line {
          width: 100;
          height: 16px;
          background: rgba(16, 28, 52, 0.5);
          padding: 5px 4px;
          margin-top: 2px;
          .line {
            position: relative;
            width: 100%;
            height: 4px;
            background: #0a284a;
            border-radius: 2px;
            div {
              position: absolute;
              left: 0;
              top: -1px;
              width: 80%;
              height: 6px;
              background: linear-gradient(270deg, #51b0ff 0%, rgba(0, 120, 255, 0) 100%);
              border-radius: 2px;
              i {
                position: absolute;
                right: 0;
                top: -2px;
                width: 10px;
                height: 10px;
                display: inline-block;
                background: #e3f2ff;
                box-shadow: 0 0 7px rgba(227, 242, 255, 1);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }
  }
  .l2-1 {
    .list-box {
      width: 100%;
      height: 363px;
      padding: 17px 0 8px;
      overflow-y: scroll;
      .list-item {
        //width: 100%;
        height: 38px;
        border-radius: 4px;
        border: 1px solid #2b97ff;
        padding: 0 39px 0 36px;
        + .list-item {
          margin-top: 5px;
        }
        .item-l {
          font-family: Source Han Sans CN;
          font-weight: bold;
          font-size: 20px;
          color: #ffffff;
          line-height: 24px;
          display: inline-flex;
          align-items: center;
          //justify-content: center;
          width: 145px;
          b {
            width: 26px;
            text-align: center;
            font-family: Geometr706 BlkCn BT;
            font-weight: 900;
            font-size: 22px;
            color: #00c9ff;
            font-style: italic;
            background: linear-gradient(0deg, #ffffff 0%, #baf0ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-right: 22px;
          }
        }
        .item-c {
          height: 20px;
          width: 145px;
          padding: 0 13px;
          background: rgba(252, 245, 194, 0.2);
          border-radius: 2px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #fcf5c2;
          line-height: 20px;
        }
        .item-r {
          width: 80px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          font-size: 20px;
          color: #dcdcdc;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          i {
            width: 12px;
            height: 12px;
            line-height: 12px;
            font-family: Geometr706 BlkCn BT;
            font-size: 20px;
            color: #dcdcdc;
            font-style: normal;
            margin-right: 11px;
            white-space: nowrap;
          }
          &.trend1 {
            background: linear-gradient(-7deg, #ffca00 0%, #ff5a00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-up.png') center center no-repeat;
              background-size: cover;
            }
          }
          &.trend2 {
            background: linear-gradient(0deg, #19490a 0.9033203125%, #7cfa00 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            i {
              background: url('~img/market/ys-down.png') center center no-repeat;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .chart-content {
    position: relative;
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin-top: 5px;
    padding: 56px 0 0 17px;
    // border: NaNpx solid;
    border-image: linear-gradient(180deg, #071322, #225087) 10 10;
    background: linear-gradient(90deg, rgba(6, 17, 29, 0) 0%, rgba(58, 90, 127, 0.208) 44%, rgba(6, 17, 29, 0) 100%);
    border-radius: 4px;
  }
  /deep/ .po {
    margin: 0;
    height: 0;
    .list {
      position: absolute;
      top: 12px;
      left: 19px;
      right: unset;
    }
  }
  .chart-statistics {
    position: relative;
    background: rgba(1, 20, 48, 0.08);
    border: 2px solid rgba(#095194, 0.2);
    padding: 17px 91px 13px 29px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    i {
      position: absolute;
      top: 0;
      left: 0;
      width: 9px;
      height: 4px;
      background: #7af0fc;
      &.i2 {
        left: 14px;
        opacity: 0.6;
        &.r {
          right: 14px;
        }
      }
      &.i3 {
        left: 27px;
        opacity: 0.2;
        &.r {
          right: 27px;
        }
      }
      &.r {
        left: unset;
        right: 0;
      }
    }
    .item-title {
      position: relative;
      height: 21px;
      perspective: 50px;
      &::after {
        position: absolute;
        left: 0;
        bottom: 0;
        content: attr(data-title);
        font-size: 18px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #eff0f1;
        line-height: 24px;
        padding-left: 10px;
        white-space: nowrap;
      }
      &::before {
        position: absolute;
        left: 0;
        bottom: 0;
        width: 211px;
        height: 20px;
        background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
        content: '';
        display: block;
        transform: rotateX(24deg);
        perspective-origin: right top;
      }
    }
    .span-label,
    .span-num {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      margin-right: 19px;
    }
    .span-num {
      color: #ff6a6a;
      margin-right: 0;
    }
    .stat-left .span-num {
      padding-left: 44px;
      font-size: 24px;
      font-weight: 900;
      color: #6acbff;
      line-height: 38px;
    }
    .span-unit {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #eff0f1;
      line-height: 29px;
      opacity: 0.6;
      margin-left: 10px;
    }
    .div-i {
      width: 16px;
      height: 16px;
      margin-right: 9px;
      display: inline-block;
      background: url('~img/commonImg/chart-stat.png') no-repeat;
      background-size: 100% 100%;
    }
    .stat-center,
    .stat-right {
      display: inline-flex;
      align-items: center;
      &.des {
        .div-i {
          transform: rotate(180deg);
        }
        .span-num {
          color: rgba(88, 236, 172, 1);
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 13px 10px;
    font-size: 18px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 20px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .chart-con {
    flex: 1;
    height: 198px;
    /deep/ .echarts > div {
      max-height: 100%;
      canvas {
        height: 100% !important;
      }
    }
  }
  .left-bottom {
    display: flex;
    > div {
      width: calc(50% - 13px);
      &:first-of-type {
        margin-right: 26px;
      }
      /deep/ .title {
        white-space: nowrap;
        width: 100%;
        #btn-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
        }
      }
      /deep/ .flex-between {
        height: 52px;
      }
    }
  }
  /deep/ .ele-dialog {
    z-index: 9999;
    &.info-modal {
      z-index: 999;
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }
    .item-label {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      line-height: 1;
      text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
      font-style: italic;
      b {
        font-size: 26px;
      }
      .comment-font {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #CE5E03FF;
        line-height: 1;
        text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
        font-style: italic;
      }
    }
    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
  }
}
</style>
